import { formActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { cloneObject } from '@utils/miscellaneous/cloneObject';

export const INITIAL_STATE_EMPTY_OBJECT = {
    areAllInputsValid: true,
    isEligiblyForSave: true,
    isFormInInitialState: true,
    isFormOnTopLevelValid: true,
    isFormSubmitted: false,
    isNonStandaloneInputChanged: false,
    nonStandaloneInputsChanged: [],
    registeredInputs: [],
    snapshot: ''
};

export const INITIAL_STATE = {};

export const compareSnapshots = (currentValues = [], form = { snapshot: '' }) => {
    const adjustToSnapshot = values => {
        return values.map(({ inputId, inputValue }) => ({
            inputId,
            value: inputValue
        }));
    };

    return JSON.stringify(adjustToSnapshot(currentValues)) === form.snapshot;
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case formActionTypes.REGISTER_FORM:
            return {
                ...state,
                [action.formName]: {
                    ...cloneObject(INITIAL_STATE_EMPTY_OBJECT)
                }
            };

        case formActionTypes.MAKE_SNAPSHOT:
            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    snapshot: action.snapshot,
                    isFormInInitialState: true,
                }
            };

        case formActionTypes.REMOVE_FORM:
            delete state[action.formName];
            return state;

        case formActionTypes.SUBMIT_FORM:
            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    isFormSubmitted: true
                }
            };

        case formActionTypes.CLEAR_SUBMISSION:
            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    isFormSubmitted: false
                }
            };

        case formActionTypes.REGISTER_INPUT:
            if(state[action.formName] && state[action.formName].registeredInputs && !state[action.formName].registeredInputs.includes(action.input)) {
                state[action.formName].registeredInputs.push(action.input);
            }

            return state;

        case formActionTypes.RE_REGISTER_INPUT:
            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    registeredInputs: state[action.formName] && state[action.formName].registeredInputs && state[action.formName].registeredInputs.map(i => {
                        if(i.inputName === action.input.inputName) {
                            return action.input;
                        } else {
                            return i;
                        }
                    })
                }
            };

        case formActionTypes.REMOVE_INPUT: {

            if(!state[action.formName]) {
                return state;
            }

             
            const inputsAfterRemoval = state[action.formName] && state[action.formName].registeredInputs && state[action.formName].registeredInputs.filter(input => input.inputId !== action.input.inputId);

            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    registeredInputs: inputsAfterRemoval,
                    isFormInInitialState: compareSnapshots(inputsAfterRemoval, state[action.formName])
                }
            };
        }
        case formActionTypes.CHANGE_INPUT_STATUS:{
            const updatedRegisteredInputs = state[action.formName] && state[action.formName].registeredInputs && state[action.formName].registeredInputs.map(
                input => input.inputId === action.input.inputId ?
                    {
                        ...input,
                        ...action.input,
                        isInputTouched: input.isInputTouched !== null
                    } : input
            );

            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    registeredInputs: updatedRegisteredInputs,
                    isFormInInitialState: compareSnapshots(updatedRegisteredInputs, state[action.formName])
                }
            };
        }
        case formActionTypes.VALIDATE_FORM:
            return {
                ...state,
                [action.formName]: {
                    ...state[action.formName],
                    ...action.payload
                }
            };

        case formActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;

        default: return state;
    }
};

// Selectors

export const selectFormSnapshot = (state, formName) => {
    const snapshot = state[formName]?.snapshot;
    return JSON.parse(snapshot ? snapshot : '[]');
};

export const isFormInInitialState = state =>
    Object.entries(state).every(([ , { isFormInInitialState } ]) => !!isFormInInitialState);

export const selectFormData = (state, formName) => state[formName] ?? INITIAL_STATE_EMPTY_OBJECT;
